import { usePromiseTracker } from "react-promise-tracker";
import { ThreeDots, Circles, Hearts, Rings } from "react-loader-spinner";

// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "./loadingIndicator.css";

const Loading = (): JSX.Element => {
	return (
		<div className="loader">
			<Rings color="#44b700" height={100} width={100} />
		</div>
	);
};

const LoadingIndicator = (): JSX.Element => {
	const { promiseInProgress } = usePromiseTracker({ delay: 1000 });
	if (promiseInProgress) {
		return <Loading />;
	} else return <></>;
};

export default LoadingIndicator;
